/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterInteractionLabelKind = (typeof FilterInteractionLabelKind)[keyof typeof FilterInteractionLabelKind];

export const FilterInteractionLabelKind = {
  interaction_label: 'interaction_label',
} as const;
